import axios from 'axios';
import qs from 'query-string';
import { buildUrl } from '../utils/helpers';
/*global SERVER, PORT */

export const supoUrl = buildUrl(
  typeof SERVER === 'undefined' || SERVER
    ? require('config').get('app.supoServiceUrl')
    : 'https://api.hipages.com.au',
  '/api/supo'
);

export const hipNewUrl =
  typeof SERVER === 'undefined' || SERVER
    ? `http://localhost:${typeof PORT === 'undefined' ? '10010' : PORT}/`
    : '/';

export const lectioUrl = buildUrl(
  typeof SERVER === 'undefined' || SERVER
    ? require('config').get('app.lectioServiceUrl')
    : 'https://api.hipages.com.au',
  '/article/api/'
);

export const tradieApiUrl = buildUrl(
  typeof SERVER === 'undefined' || SERVER
    ? require('config').get('app.tradieServiceUrl')
    : 'https://api.hipages.com.au/hip-new/tradie/v1',
  ''
);

export const locationApi = axios.create({
  baseURL: 'https://cerebro.k8s.hipages.com.au/suggest/location',
});

export const supo = axios.create({ baseURL: supoUrl });
export const hipNew = axios.create({ baseURL: hipNewUrl });
export const lectio = axios.create({ baseURL: lectioUrl });
export const tradieApi = axios.create({ baseURL: tradieApiUrl });

export type RegisterFields = {
  firstName: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  email: string;
};

export function register(data: Partial<RegisterFields>) {
  const dataToPost = {
    email: data.email,
    firstname: data.firstName,
    lastname: data.lastName,
    password: data.password,
    password_confirm: data.confirmPassword,
  };
  return hipNew.post('/register-ajax', qs.stringify(dataToPost));
}
